<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-text class="pt-8">
        <div class="text-center mb-4">
          <div class="step-title">{{ texts.settings.accountStatement.title }}</div>
          <div class="step-subtitle">
            {{ texts.settings.accountStatement.subtitle }}
          </div>
        </div>
        <div class="d-flex justify-center align-center py-4">
          <v-btn
            class="month-picker-btn"
            @click="showMonthPicker = true"
            elevation="0"
            outlined
            style="justify-content: space-between; min-width: 250px; border-radius: 10px;"
          >
            <span class="month-picker-label">
              {{ monthsFull[selectedMonth] }}, {{ selectedYear }}
            </span>
            <v-icon color="#0075B8" right>mdi-calendar</v-icon>
          </v-btn>
        </div>

        <!-- Month Picker Dialog -->
        <v-dialog v-model="showMonthPicker" max-width="300px" persistent>
          <v-card>
            <v-card-text>
              <div class="month-picker">
                <div class="header d-flex justify-space-between align-center py-2">
                  <v-btn icon @click="prevYear"><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <span class="year font-weight-bold">{{ monthPickerYear }}</span>
                  <v-btn icon @click="nextYear"><v-icon>mdi-chevron-right</v-icon></v-btn>
                </div>
                <div class="months-grid">
                  <v-btn
                    v-for="(month, i) in monthsAbbr"
                    :key="i"
                    :color="selectedMonth === i && selectedYear === monthPickerYear ? '#0075B8' : ''"
                    :class="{ 'white--text': selectedMonth === i && selectedYear === monthPickerYear }"
                    @click="selectMonthModal(i)"
                    depressed
                    small
                    class="month-btn ma-1"
                    :disabled="isMonthDisabled(i)"
                  >
                    {{ month }}
                  </v-btn>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="justify-center pt-0 pb-4">
              <v-btn
                text
                color="#0075B8"
                @click="showMonthPicker = false"
                style="text-transform: none; font-family: 'montserrat-semibold';"
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-around pb-6">
        <v-btn
          rounded
          outlined
          color="#0075B8"
          @click="close"
          elevation="3"
          min-width="150px"
          style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
        >
          {{ texts.settings.emailTwoFactor?.cancel || 'Cancelar' }}
        </v-btn>
        <v-btn
          rounded
          color="#0075B8"
          @click="downloadStatement"
          :loading="loading"
          elevation="3"
          min-width="150px"
          style="border-radius: 36px; text-transform: none; color: #fff; font-family: 'montserrat-semibold';"
        >
          {{ texts.incomes?.download || 'Descargar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogAccountStatement",
  props: {
    value: Boolean,
    texts: Object
  },
  data() {
    return {
      loading: false,
      showMonthPicker: false,
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      monthPickerYear: new Date().getFullYear(),
      monthsFull: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      monthsAbbr: [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ]
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    selectLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.updateMonthLabels();
      }
    },
    selectLanguage() {
      this.updateMonthLabels();
    }
  },
  methods: {
    updateMonthLabels() {
      if (this.selectLanguage === 'en') {
        this.monthsFull = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        this.monthsAbbr = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
      } else {
        this.monthsFull = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        this.monthsAbbr = [
          'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
          'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];
      }
    },
    close() {
      this.show = false;
    },
    prevYear() {
      this.monthPickerYear--;
    },
    nextYear() {
      const currentYear = new Date().getFullYear();
      if (this.monthPickerYear < currentYear) {
        this.monthPickerYear++;
      }
    },
    isMonthDisabled(monthIdx) {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();

      if (this.monthPickerYear > currentYear) return true;
      // Permitir el mes actual (monthIdx > currentMonth en vez de >=)
      if (this.monthPickerYear === currentYear && monthIdx > currentMonth) return true;

      return false;
    },
    selectMonthModal(monthIdx) {
      this.selectedMonth = monthIdx;
      this.selectedYear = this.monthPickerYear;
      this.showMonthPicker = false;
    },
    async downloadStatement() {
      this.loading = true;
      const month = this.selectedMonth + 1;
      const year = this.selectedYear;

      try {
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/statements/statements`,
          { month, year },
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            },
            responseType: "arraybuffer"
          }
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Estado_de_cuenta_${this.selectedYear}-${String(month).padStart(2, '0')}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        this.$parent.mixError(
          error.response?.data?.message || 'Error al descargar el estado de cuenta',
          error.response?.status
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.step-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.step-subtitle {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}

.month-picker-btn {
  border: 1px solid #0075B8;
  background-color: #fff;
  text-transform: none;
}

.month-picker-label {
  font-family: 'montserrat-medium';
  color: #333;
}

.months-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}

.month-btn {
  text-transform: none;
  font-size: 12px;
}

.year {
  font-size: 18px;
  color: #193D6E;
}
</style>
